import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import PixleeFeed from './_shared/pixlee/PixleeFeed';
import ErrorBoundary from '../utils/react/ErrorBoundary';
import { ApolloProvider } from '@apollo/client';
import defaultClient from './_shared/apolloClient';
import { isLocal } from '../utils/environment';

const DefaultPostsPerRequest = '30';
const requestURL =
  window.page_data?.request_url ||
  `https://distillery.pixlee.com/api/v2/albums/14140960/photos?sort={"approved_time":true,"desc":true}&page=1&per_page=${DefaultPostsPerRequest}&api_key=TB6jIdhJVSuV0LWK7elH`;

ReactDOM.render(
  <ErrorBoundary className="centered-message" key={(!isLocal || new Date()).toString()}>
    <Suspense fallback={null}>
      <ApolloProvider client={defaultClient}>
        <PixleeFeed requestURL={requestURL} isPageLayout />
      </ApolloProvider>
    </Suspense>
  </ErrorBoundary>,
  document.getElementById('PixleeFeed')
);
